import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const LinktreeIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="500"
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height="500"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="c7f37f878e">
          <path
            d="M 47 14.902344 L 329 14.902344 L 329 359.902344 L 47 359.902344 Z M 47 14.902344 "
            clip-rule="nonzero"
          />
        </clipPath>
      </defs>
      <rect
        x="-37.5"
        width="450"
        fill="#ffffff"
        y="-37.499999"
        height="449.999989"
        fill-opacity="1"
      />
      <rect
        x="-37.5"
        width="450"
        fill="#1c1c27"
        y="-37.499999"
        height="449.999989"
        fill-opacity="1"
      />
      <g clip-path="url(#c7f37f878e)">
        <path
          fill="#ffffff"
          d="M 212.707031 99.042969 L 270.269531 39.863281 L 303.679688 74.082031 L 243.296875 131.65625 L 328.234375 131.65625 L 328.234375 179.160156 L 242.894531 179.160156 L 303.679688 238.210938 L 270.269531 271.761719 L 187.75 188.824219 L 105.226562 271.761719 L 71.816406 238.34375 L 132.601562 179.296875 L 47.261719 179.296875 L 47.261719 131.65625 L 132.199219 131.65625 L 71.816406 74.082031 L 105.226562 39.863281 L 162.792969 99.042969 L 162.792969 14.902344 L 212.707031 14.902344 Z M 162.792969 247.203125 L 212.707031 247.203125 L 212.707031 359.929688 L 162.792969 359.929688 Z M 162.792969 247.203125 "
          fill-opacity="1"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  </SvgIcon>
);

export default LinktreeIcon;
